/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type DevelopmentActionBar_development$ref = any;
type DevelopmentActionCard_development$ref = any;
type DevelopmentDescription_development$ref = any;
type DevelopmentHeader_development$ref = any;
type DevelopmentLocation_development$ref = any;
type DevelopmentLots_development$ref = any;
type DevelopmentProjectConsortium_development$ref = any;
export type DevelopmentImageBackground = "black" | "white";
export type DevelopmentImageCrop = "fill" | "fit";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Development_development$ref: FragmentReference;
declare export opaque type Development_development$fragmentType: Development_development$ref;
export type Development_development = {|
  +developmentImages: ?$ReadOnlyArray<{|
    +title: ?string,
    +displayOnListing: boolean,
    +crop: DevelopmentImageCrop,
    +backgroundColor: DevelopmentImageBackground,
    +image: {|
      +url: string
    |},
  |}>,
  +$fragmentRefs: DevelopmentHeader_development$ref & DevelopmentProjectConsortium_development$ref & DevelopmentDescription_development$ref & DevelopmentLocation_development$ref & DevelopmentActionCard_development$ref & DevelopmentActionBar_development$ref & DevelopmentLots_development$ref,
  +$refType: Development_development$ref,
|};
export type Development_development$data = Development_development;
export type Development_development$key = {
  +$data?: Development_development$data,
  +$fragmentRefs: Development_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Development_development",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentImage",
      "kind": "LinkedField",
      "name": "developmentImages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayOnListing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "crop",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentHeader_development"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentProjectConsortium_development"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentDescription_development"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentLocation_development"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentActionCard_development"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentActionBar_development"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DevelopmentLots_development"
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '5b20a1181f35d81b73058cb3b301e6d3';

export default node;
